import {PromotionTracker} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/tracker.types';
import {
  trackContentInteraction,
  TrackingBrandInteraction,
  TrackingContentInteraction,
  TrackingStoryInteraction,
} from '@aboutyou/legacy-tracking-sdk';
import {useCallback} from 'react';
import {useTracking} from '../utils/utils';

export const useTrackContentInteraction = ({
  contentId,
  contentName,
  contentPath,
  type,
  ...promotionTracker
}: {
  contentId: number;
  contentName: string;
  contentPath: string;
  type: TrackingContentInteraction['type'];
} & Partial<PromotionTracker>) => {
  const {TrackingClient} = useTracking();

  return useCallback(
    (action: 'like' | 'unlike' | 'dislike') => {
      TrackingClient?.track(
        trackContentInteraction({
          interaction:
            type === 'brand'
              ? ({
                  type,
                  action,
                  label: contentId.toString(),
                  url: contentPath,
                  name: contentName,
                  ...promotionTracker,
                } as TrackingBrandInteraction)
              : ({
                  type,
                  action,
                  label: contentId.toString(),
                  url: contentPath,
                  headline: contentName,
                } as TrackingStoryInteraction | TrackingStoryInteraction),
        }),
      );
    },
    [contentId, contentPath, contentName, promotionTracker],
  );
};
